import { formatCurrency } from '@/services/convert'
import { createTreeData } from '@/services/grid'
import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import TreeTable from 'primevue/treetable'
import Column from 'primevue/column'
import Checkbox from 'primevue/checkbox'

export default {
  components: {
    'tree-table': TreeTable,
    column: Column,
    checkbox: Checkbox,
  },
  props: ['groupDetails'],
  data: function() {
    return {
      visible: false,
      loading: true,
      formatCurrency: formatCurrency,
      treeData: [],
      selectedNodes: undefined,
      checkAll: false,
      keyCount: 0,
      addFrom: 'Grouping Bank',
      filters: {},
      width: '110rem',
      padding: '0px',
      bodyWidth: '35rem',
      showCheckbox: true,
      closable: true,
    }
  },
  beforeMount() {
    this.visible = true
    this.getTakeoffs('groupingBank', 'Grouping Bank')
    window.addEventListener('resize', this.detectViewPortListener)
  },
  mounted() {
    this.$root.$off('stopLoader')
    this.$root.$on('stopLoader', this.stopLoader)
  },
  methods: {
    handleCancel() {
      this.visible = false
      this.addFrom = 'Grouping Bank'
      this.treeData = []
      this.selectedNodes = undefined
      this.$emit('onClose', false)
    },

    onChange(value) {
      let type
      switch (value) {
        case 'Grouping Bank':
          type = 'groupingBank'
          break
        case 'Tenant Bank':
          type = 'tenantBank'
          break
        case 'Template':
          type = 'template'
          break

        default:
          break
      }
      this.checkAll = false
      this.treeData = []
      this.selectedNodes = undefined
      this.getTakeoffs(type, value)
    },

    createTreeData(value, data) {
      let takeoffs = []
      switch (value) {
        case 'Grouping Bank':
          takeoffs = data.groupingBanks
          break
        case 'Tenant Bank':
          takeoffs = data.tenantBanks
          break
        case 'Template':
          takeoffs = data.templates
          break

        default:
          break
      }
      const treeData = createTreeData(takeoffs, value)
      this.treeData = treeData.treeData
      this.keyCount = treeData.keyCount
      this.bodyWidth = 'auto'
      this.hideCheckbox()
    },

    getTakeoffs(addFrom, type) {
      this.loading = true
      const url = projectAPIs.project.asset.estimate.takeoff[addFrom](
        this.$route.params.id,
        this.groupDetails.assetId,
      )
      instance
        .get(url)
        .then(response => {
          this.loading = false
          const data = _.get(response.data, 'result', [])
          this.createTreeData(type, data)
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    selectAll(event) {
      if (this.checkAll) {
        const selectedata = []
        const treeData = this.treeData
        treeData.map(data => {
          selectedata[data.key] = { checked: true, partialChecked: false }
          if (this.addFrom === 'Grouping Bank' || this.addFrom === 'Template') {
            if (data.children) {
              data.children.map(firstLevel => {
                selectedata[firstLevel.key] = {
                  checked: true,
                  partialChecked: false,
                }
                if (firstLevel.children) {
                  firstLevel.children.map(secondLevel => {
                    selectedata[secondLevel.key] = {
                      checked: true,
                      partialChecked: false,
                    }
                    if (secondLevel.children) {
                      secondLevel.children.map(thirdLevel => {
                        selectedata[thirdLevel.key] = {
                          checked: true,
                          partialChecked: false,
                        }
                        if (thirdLevel.children) {
                          thirdLevel.children.map(fourthLevel => {
                            selectedata[fourthLevel.key] = {
                              checked: true,
                              partialChecked: false,
                            }
                          })
                        }
                      })
                    }
                  })
                }
              })
              this.selectedNodes = selectedata
            }
          } else {
            if (data.children) {
              data.children.map(firstLevel => {
                selectedata[firstLevel.key] = {
                  checked: true,
                  partialChecked: false,
                }
                if (firstLevel.children) {
                  firstLevel.children.map(secondLevel => {
                    selectedata[secondLevel.key] = {
                      checked: true,
                      partialChecked: false,
                    }
                    secondLevel.children.map(thirdLevel => {
                      selectedata[thirdLevel.key] = {
                        checked: true,
                        partialChecked: false,
                      }
                      thirdLevel.children.map(fourthLevel => {
                        selectedata[fourthLevel.key] = {
                          checked: true,
                          partialChecked: false,
                        }
                        if (fourthLevel.children) {
                          fourthLevel.children.map(fifthLevel => {
                            selectedata[fifthLevel.key] = {
                              checked: true,
                              partialChecked: false,
                            }
                          })
                        }
                      })
                    })
                  })
                }
              })
              this.selectedNodes = selectedata
            }
          }
        })
      } else {
        this.selectedNodes = undefined
      }
    },

    onNodeSelect(node) {
      this.checkAll =
        this.keyCount.length === Object.keys(this.selectedNodes).length
    },

    onNodeUnselect(node) {
      if (_.isEmpty(this.selectedNodes)) {
        this.selectedNodes = undefined
      } else if (Object.keys(this.selectedNodes).length > 0) {
        if (
          Object.keys(this.selectedNodes).every(
            i => !this.selectedNodes[i].checked,
          )
        ) {
          this.selectedNodes = undefined
        }
      }
      this.checkAll = false
    },

    addTakeoffs() {
      let isValid = false
      const request = []
      let data = null
      const url = projectAPIs.project.asset.estimate.takeoff.bankTakeoff(
        this.$route.params.id,
        this.groupDetails.assetId,
        this.groupDetails.id,
      )
      if (
        this.selectedNodes &&
        !_.isEmpty(this.selectedNodes) &&
        Object.keys(this.selectedNodes).length > 0
      ) {
        let nodes = { ...this.selectedNodes }
        nodes = Object.keys(this.selectedNodes).filter(i => i.split(' ~ ').length > 5)
        nodes.forEach(key => {
          const splitKey = key.split(' ~ ')
          if (splitKey && splitKey.length === 6) {
            if (this.selectedNodes[key].checked) {
              data = JSON.parse(splitKey[5])
              isValid = true
            }
          } else if (splitKey && splitKey.length === 7) {
            if (this.selectedNodes[key].checked) {
              data = JSON.parse(splitKey[6])
              isValid = true
            }
          }
          if (data) {
            request.push({
              mTakeoffId: data.mTakeoffId,
              mTakeoffGroupingId: data.mTakeoffGroupingId,
              quantity: data.quantity,
              calculation: data.calculation,
              isCalculationMatched: data.isCalculationMatched,
              isValidTakeoff: data.isValidTakeoff,
              interiorGroupId: data.interiorGroupId,
              tenantBankId: data.tenantBankId,
              templateId: data.templateId,
              source: data.source,
              additionalDescription: data.additionalDescription,
            })
          }
        })
      }
      if (isValid && request.length > 0) {
        this.closable = false
        this.loading = true
        const msg = 'Please wait...'
        this.$root.$emit('popupUpdation', true, true, msg)
        instance
          .post(url, request)
          .then(response => {
            this.checkAll = false
            this.selectedNodes = undefined
            this.$emit('addNewTakeoffs', true)
          })
          .catch(err => {
            this.closable = true
            this.loading = false
            this.$root.$emit('popupUpdation', false, true, null)
            errorService(err)
          })
      }
    },

    detectViewPortListener() {
      if (window.innerWidth > 1450) {
        this.width = '110rem'
        this.padding = '0px !important'
      } else if (window.innerWidth < 1450) {
        this.width = '100%'
        this.padding = '10px !important'
      } else {
        this.width = '110rem'
        this.padding = '0px !important'
      }
    },

    onFilter() {
      if (this.filters && this.filters.description) {
        this.showCheckbox = false
        this.checkAll = false
        this.selectedNodes = undefined
      } else {
        this.showCheckbox = true
        this.hideCheckbox()
      }
    },

    stopLoader() {
      this.closable = true
      this.loading = false
    },

    onNodeExpand(node) {
      this.hideCheckbox()
    },

    hideCheckbox() {
      setTimeout(() => {
        const element = document.querySelectorAll('td')
        if (element) {
          const list = [...element].filter(i => i.innerText === 'Takeoff Description')
          list.forEach(node => {
            node.childNodes[1].classList.add('hide-checkbox')
          })
        }
      }, 50)
    },
  },
}
